<template>
  <div>
    <Navbar />
    <Breadcrumb />
    <b-card class="col-12" title="Import Users">
      <b-tabs class="col-12 px-0 mx-auto mt-2" content-class="mt-3">
        <b-tab class="px-0 col-12 border-0">
          <template v-slot:title>
            <div class="col-12 text-center">
              Step 1 - Select Excel file
            </div>
          </template>
          <b-card class="border-0 col-12">
            <b-alert :show="this.message != ''" dismissable variant="danger" v-html="this.message"></b-alert>
            <div v-show="this.uploading == false">
              <p>This program will import users to the GDQ system. If a user's e-mail address is already found in the system, the user information will be updated with the information in the Excel file.
              <p>Your Excel file should have one heading row and one row for each user with the following columns:</p>
              <ul>
                <li>Column A: User name - required - this is used for login and must be unique and cannot contain spaces of special characters</li>
                <li>Column B: Password - leave this field blank to not update the password fo existing users. If the field is blank, any new users in the Excel file will get password 'gdq2020!'</li>
                <li>Column C: E-mail address - must be unique</li>
                <li>Column D: Family Name - optional</li>
                <li>Column E: First Name - optional</li>
                <li>Column F: Telephone - optional</li>
                <li>Column G: Country Name - if no country name is specified, the system will set country to Sweden</li>
                <li>Column H: Affiliated Company Name - optional</li>
                <li>Column I: VAT Number - optional</li>
                <li>Column J: Is Administrator - put the number 1 in this column to indicate that the user is an administrator</li>
                <li>Column K: Is ToT - put the number 1 in this column to indicate that the user is a ToT</li>
                <li>Column L: Is Consultant - put the number 1 in this column to indicate that the user is a consultant</li>
              </ul>
            </div>
            <div class="text-center">
              <b-spinner v-show="this.uploading" label="Uploading" style="width: 4rem;height: 4rem;" type="grow" variant="primary"></b-spinner>
            </div>
            <p v-show="this.uploading == false">
              <a class="button" href="/GDQ_Consultants_Import_Template.xls" target="_blank" download="/GDQ_Consultants_Import_Template.xls">
                <span class="icon-file-excel"></span>&nbsp;Click here to download the Excel template
              </a>
            </p>
            <b-form-group v-show="this.uploading == false">
              <b-form-file
                class="col-8"
                v-model="import_file"
                ref="import_file"
                accept="application/vnd.ms-excel"
                placeholder="Choose a file or drop it here."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <span class="col-4 float-right">
              </span>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab class="px-0 col-12 border-0">
          <template v-slot:title>
            <div class="col-12 text-center">
              Step 2 - Check file format
            </div>
          </template>
          <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
            <b-row>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab class="px-0 col-12 border-0">
          <template v-slot:title>
            <div class="col-12 text-center">
              Step 3 - Import data
            </div>
          </template>
          <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
            <b-row>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';

export default {
  name: 'ImportConsultants',
  components: {
    Navbar,
    Breadcrumb
  },
  created() {
  },
  data() {
    return {
      message: '',
      uploading: false,
      import_file: null,
      import_file_valid: null,
    }
  },
  computed: {
  },
  watch: {
    import_file() {
      this.submitFile();
    },
  },
  methods: {
    //------------------
    // Upload Excel file
    //------------------
    submitFile() {
      if (this.import_file != null && this.import_file.name != '') {
        this.uploading = true;
        const fd = new FormData();
        fd.append('group_id',this.$store.state.currentgroup_id);
        fd.append('file',this.import_file);
        this.$store.dispatch('users_upload', fd)
        .then((result) => {
          if (result.data.errors.length > 0) {
            for (var i=0; i< result.data.errors.length; i++) {
              this.message = this.message + result.data.errors[i]+'<br>';
            }
          }
        })
        .then(() => {
          this.uploading = false;
        });
      }
    },
    checkform() {
      var formok = true;
      this.import_file_valid = true;
      if (this.import_file == null && this.import_id < 1) {
        this.import_file_valid = false;
        formok = false;
      }
      return formok;
    },
    importfile_save() {
    },
  },
}
</script>
<style>
</style>
